<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />
            <div class="vertical-flow">
                <div class="listing-header mb-3">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("situacao-cliente") }}
                        </h1>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            @click="fecharModal()"
                        >
                            {{ $t("cancelar") }}
                        </button>
                        <button
                            v-if="
                                (!isUpdate && permissao.create) ||
                                (isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />

                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-3">
                            <v-input
                                :id="generateId(1)"
                                ref="idsituacaoerpInput"
                                v-model="situacaocliente.idsituacaoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                msg="msg-campo-obrigatorio"
                                :invalid="!situacaocliente.idsituacaoerp"
                                uppercase
                                required
                            />
                        </div>
                        <div class="column is-9">
                            <v-input
                                :id="generateId(2)"
                                ref="descricaoInput"
                                v-model="situacaocliente.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="descricao"
                                msg="msg-campo-obrigatorio"
                                :invalid="!situacaocliente.descricao"
                                uppercase
                                required
                            />
                        </div>
                        <div class="column is-2">
                            <vss-select
                                title="liberapedido"
                                :id="generateId(3)"
                                ref="liberapedidoSelect"
                                :options="liberapedidoSelect"
                                v-model="liberapedidoSelected"
                                :mlLabels="true"
                                required
                            />
                        </div>
                        <div class="column is-6">
                            <v-input
                                :id="generateId(5)"
                                v-model="situacaocliente.finalidade"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="finalidade"
                                ref="finalidadeInput"
                                required
                            />
                        </div>
                        <div class="column is-2">
                            <label for="color">{{
                                $t("selecione-uma-cor")
                            }}</label>
                            <color-picker
                                :id="generateId(5)"
                                type="text"
                                :color="situacaocliente.cor.startsWith('#') ? situacaocliente.cor : '#' + situacaocliente.cor"
                                ref="cpInput"
                                :required="true"
                                @colorpicked="colorpicked"
                            />
                        </div>
                        <div class="column is-2">
                            <vss-select
                                title="situacao"
                                :id="generateId(9)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="!isUpdate"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SituacaoService from "@/services/SituacaoService";
import SituacaoValidation from "@/services/validations/vendas/SituacaoValidation";
import Message from "@/models/Message";
import ColorPicker from "@/components/shared/form/ColorPicker";

export default {
    components: {
        ColorPicker,
    },
    data() {
        return {
            integracao:
                this.$store.state.user.tabelasERPWebServer.includes("SITUACAO"),
            isSaving: false,
            service: new SituacaoService(this.$http, this.$router),
            validation: new SituacaoValidation(this.$root.msgs),
            situacaocliente: {
                id: null,
                idempresa: null,
                descricao: null,
                cor: "#000000",
                liberapedido: null,
                finalidade: null,
                situacao: null,
            },
            msgs: [],
            situacoes: [
                { label: "inativo", id: 0 },
                { label: "ativo", id: 1 },
            ],
            liberapedidoSelect: [
                { label: "nao", id: "N" },
                { label: "sim", id: "S" },
            ],
            liberapedidoSelected: { label: "sim", id: "S" },
            situacao: { label: "ativo", id: 1 },
            isUpdate: false,
            msgPorcentagemInvalida: "porcentagem-invalida",
            invalidPorcentagemCif: false,
            invalidPorcentagemFob: false,
            isLoading: false,
            isChanged: false,
            isLoadingEdit: false,
        };
    },
    watch: {
        situacaocliente: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.isChanged = true;
                }
            },
        },
    },
    created() {
        this.isChanged = false;

        this.permissao = this.hasPermissionAccess(
            "vendas",
            "clientes",
            "ven-situacao"
        );
        if (!this.permissao.create) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "situacao-cliente" },
            });
        }
    },
    methods: {
        colorpicked(color) {
            this.situacaocliente.cor = color;
        },
        generateId(numberId) {
            return this.$route.name + "-" + numberId;
        },
        fecharModal() {
            // @85181 - Confirmação ao fechar adicionada no modal de Região
            if (this.isChanged) {
                this.$root.confirm({
                    message: this.$t("msg-tem-certeza-alteracoes"),
                    onConfirm: (_) => {
                        this.isChanged = false;
                        this.$emit("fecharModal");
                    },
                });
            } else {
                this.$emit("fecharModal");
            }
        },
        // Emite ao componente pai se houve alteração em um campo select
        sendIsChanged() {
            if (!this.isLoadingEdit) this.isChanged = true;
        },
        save() {
            this.isLoading = true;
            this.isLoadingEdit = true;

            if (this.validation.validate(this.situacaocliente, this.$refs)) {
                let situacaoTemp = Object.assign({}, this.situacaocliente);
                situacaoTemp = this.mapTosave(situacaoTemp);
                situacaoTemp.situacao = this.situacao.id;
                situacaoTemp.liberapedido = this.liberapedidoSelected.id;
                this.isSaving = true;
                this.service
                    .save(situacaoTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = "msg-save-situacao";
                            if (this.situacaocliente.id != null) {
                                msg = "msg-edit-situacao";
                            }
                            this.isChanged = false;
                            this.msgs.push(new Message("success", msg, true));
                            
                            this.$emit("fecharModal", value.content)
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(
                                    new Message("alert", value.message, true)
                                );
                            } else {
                                this.msgs.push(
                                    new Message(
                                        "error",
                                        "msg-problema-realizar-acao",
                                        true
                                    )
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(
                            new Message("error", "msg-erro-load", true)
                        );
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                        this.isLoadingEdit = false;
                    });
            } else {
                this.$root.showMessage(
                    "alert",
                    "msg-campos-obrigatorios",
                    true
                );
                this.isLoading = false;
                this.isLoadingEdit = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    .page {
        position: relative;
    }
}
</style>